import React from 'react';
import PropTypes from 'prop-types';

import { PATH } from '../constants/path';
import LinkButtonComponent from './button/LinkButtonComponent';
import { convertHtmlToReactDomWithParams } from '../utils/htmlUtils';

import './CustomerServiceComponent.scss';

class CustomerServiceComponent extends React.Component {
    render() {
        const { i18n } = this.props;
        return (
            <div className={`call-sav ${this.props.cssClass ? this.props.cssClass : ''}`}>
                <div className="titre">{i18n.title}</div>
                <div className="text">
                    <p>{convertHtmlToReactDomWithParams(i18n.text1)}</p>
                    <p>{convertHtmlToReactDomWithParams(i18n.text2)}</p>
                </div>
                <LinkButtonComponent
                    text={i18n.button}
                    title="Nous contacter"
                    color="fifth"
                    to={PATH.CONTACTREQUEST_PATH}
                />
            </div>
        );
    }
}

CustomerServiceComponent.propTypes = {
    cssClass: PropTypes.string,
    i18n: PropTypes.object.isRequired
};

export default CustomerServiceComponent;



// WEBPACK FOOTER //
// ./src/components/CustomerServiceComponent.js